<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4499 0.262028V1.78123C12.4499 1.92614 12.3346 2.04344 12.1921 2.04344H10.9601V12.4435C10.9601 12.5884 10.8447 12.7057 10.7022 12.7057H9.11217C8.96967 12.7057 8.85432 12.5884 8.85432 12.4435V2.04361H7.64106V12.4436C7.64106 12.5885 7.52589 12.7058 7.38322 12.7058H5.90799C5.76548 12.7058 5.65014 12.5885 5.65014 12.4436V8.49363C5.14115 8.6527 4.66447 8.73311 4.22871 8.73311C3.01906 8.73311 2.00778 8.31376 1.22307 7.48642C0.440759 6.66188 0.0441895 5.59751 0.0441895 4.3225C0.0441895 2.97059 0.468778 1.89852 1.30592 1.13656C2.13516 0.382467 3.29857 1.94839e-07 4.76417 1.94839e-07H12.1917C12.3346 -0.000174607 12.4499 0.117292 12.4499 0.262028Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconPT',
  props: {
    width: {
      type: [String, Number],
      default: 13,
    },
    height: {
      type: [String, Number],
      default: 13,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
}
</script>
